import TransactionSummaryListing from './components/TransactionSummaryListing'

export default function TransactionSummary() {
	return <TransactionSummaryListing />
}
